
webpack.register(
    'components/video-landing/live-channel/live-channel',
    function() {
        return require('components/video-landing/live-channel/live-channel');
    },
    false
);
webpack.register(
    'components/sponsor/sponsor',
    function() {
        return require('components/sponsor/sponsor');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/video-landing/live-channel/live-channel'/>\r\n<can-import from='components/sponsor/sponsor'/>\r\n\r\n{{#if liveVideoCards.length}}\r\n    <div class=\"c-live-streaming-schedule\">\r\n        <header class=\"s-streams__header\">\r\n            {{#if sponsorIsAvailable}}\r\n                <div class=\"s-sponsor\">\r\n                    <sponsor {sponsor}=\"sponsor\"></sponsor>\r\n                </div>\r\n            {{/if}}\r\n            <p class=\"s-streams-title\">Live Streaming</p>\r\n            <p class=\"s-timezone\">\r\n                All times in your local time ({{ timezoneCode }})\r\n            </p>\r\n        </header>\r\n        <div class=\"s-streams__list\">\r\n            {{#each liveVideoCards}}\r\n                <div class=\"s-stream\">\r\n                    <live-channel {live-video-card}=\".\"></live-channel>\r\n                </div>\r\n            {{/if}}\r\n        </div>\r\n    </div>\r\n{{/if}}");